<script setup lang="ts">
import type { BarChartData, BarChartOptions } from '~/components/nrjx/chart/new/bar/index.vue';

const dataExample: BarChartData[] = [
  { key: 'Jan 2020', barValues: [11.1, 8.5], lineValue: 5.2 },
  { key: 'Feb 2020', barValues: [18.3, 15.2], lineValue: 6.4 },
  { key: 'Mar 2020', barValues: [25.1, 21.3], lineValue: 9.8 },
  { key: 'Apr 2020', barValues: [35.5, 30.1], lineValue: 14.2 },
  { key: 'May 2020', barValues: [31.7, 27.8], lineValue: 18.5 },
  { key: 'Jun 2020', barValues: [25.8, 22.4], lineValue: 23.7 },
  { key: 'Jul 2020', barValues: [15.8, 12.9], lineValue: 26.1 },
  { key: 'Aug 2020', barValues: [24.8, 20.5], lineValue: 25.4 },
  { key: 'Sep 2020', barValues: [32.5, 28.7], lineValue: 21.9 },
  { key: 'Oct 2020', barValues: [36.7, 32.1], lineValue: 16.3 },
  { key: 'Nov 2020', barValues: [34.7, 30.2], lineValue: 10.8 },
  { key: 'Dec 2020', barValues: [42.7, 37.5], lineValue: 6.2 },
  { key: 'Jan 2021', barValues: [39.7, 35.1], lineValue: 4.7 },
  { key: 'Feb 2021', barValues: [41.3, 36.8], lineValue: 5.9 },
  { key: 'Mar 2021', barValues: [45.1, 40.2], lineValue: 10.3 },
  { key: 'Apr 2021', barValues: [48.5, 43.1], lineValue: 15.1 },
  { key: 'May 2021', barValues: [51.7, 46.3], lineValue: 19.2 },
  { key: 'Jun 2021', barValues: [55.8, 50.2], lineValue: 24.5 },
  { key: 'Jul 2021', barValues: [58.8, 53.4], lineValue: 27.3 },
  { key: 'Aug 2021', barValues: [62.8, 57.1], lineValue: 26.8 },
  { key: 'Sep 2021', barValues: [65.5, 60.2], lineValue: 22.4 },
  { key: 'Oct 2021', barValues: [68.7, 63.1], lineValue: 17.1 },
  { key: 'Nov 2021', barValues: [71.7, 66.3], lineValue: 11.3 },
  { key: 'Dec 2021', barValues: [75.7, 70.2], lineValue: 6.9 },
  { key: 'Jan 2022', barValues: [78.7, 73.4], lineValue: 5.1 },
  { key: 'Feb 2022', barValues: [81.3, 76.1], lineValue: 6.3 },
  { key: 'Mar 2022', barValues: [85.1, 80.2], lineValue: 10.5 },
  { key: 'Apr 2022', barValues: [88.5, 83.1], lineValue: 15.8 },
  { key: 'May 2022', barValues: [91.7, 86.3], lineValue: 20.4 },
  { key: 'Jun 2022', barValues: [95.8, 90.2], lineValue: 25.2 },
  { key: 'Jul 2022', barValues: [98.8, 93.4], lineValue: 28.7 },
  { key: 'Aug 2022', barValues: [102.8, 97.1], lineValue: 27.9 },
  { key: 'Sep 2022', barValues: [105.5, 100.2], lineValue: 23.1 },
  { key: 'Oct 2022', barValues: [108.7, 103.1], lineValue: 17.6 },
  { key: 'Nov 2022', barValues: [111.7, 106.3], lineValue: 11.9 },
  { key: 'Dec 2022', barValues: [115.7, 110.2], lineValue: 7.2 },
];

const dataExempleSingleBar: BarChartData[] = dataExample.map((data) => ({
  key: data.key,
  barValues: [data.barValues[0] ?? 0],
}));

const options: BarChartOptions = {
  height: 'h-[50vh]',
  y2: {
    unit: '°C',
  },
  y: {
    unit: 'kWh',
  },
  tooltip: (groupBarIndex: number) => {
    const data = dataExample[groupBarIndex];
    if (!data) return undefined;

    return {
      subtitle: data.key,
      body: [
        {
          title: 'Consommation',
          value: data.barValues.map((value) => value.toString()).join(', '),
        },
        {
          title: 'Température',
          value: `${data.lineValue}°C`,
        },
      ],
      footer: data.key,
    };
  },
};
</script>
<template>
  <div class="flex flex-col gap-4">
    <ui-card title="Multiples Bars">
      <div class="border border-gray-200 rounded p-4">
        <nrjx-chart-new-bar :data="dataExample" :options="options" />
      </div>
    </ui-card>
    <ui-card title="Barres uniques">
      <div class="border border-gray-200 rounded p-4">
        <nrjx-chart-new-bar :data="dataExempleSingleBar" :options="options" />
      </div>
    </ui-card>
    <ui-card title="Etat de chargement">
      <div class="border border-gray-200 rounded p-4">
        <nrjx-chart-new-bar :data="dataExempleSingleBar" :loading="true" :options="options" />
      </div>
    </ui-card>
  </div>
</template>
